/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jan 03 2025
 **/

import { css } from "@emotion/react";

export const WhiteboardRootStyle = (zIndex: number) => css`
	font-size: 14px;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	position: fixed;
	color: black;
	pointer-events: none;
	overflow: hidden;
	z-index: ${zIndex};

	&.hide {
		display: none;
	}
`;
